(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-behaviour"] && !Shopify.designMode) return;
  try {
    if (!window.highwayAjaxCartReady) {
  window.highwayAjaxCartReady = true;
  let statusTimer;
  const pendingForms = new WeakSet();
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const status = document.querySelector('[data-cart-status]');
    if (!(form instanceof HTMLFormElement) || !status || !form.action.includes('/cart/add')) return;
    event.preventDefault();
    if (pendingForms.has(form)) return;
    pendingForms.add(form);
    const button = form.querySelector('button[type="submit"]');
    let itemAdded = false;
    if (button) button.disabled = true;
    try {
      const response = await fetch(status.dataset.addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const problem = await response.json().catch(() => ({}));
        throw new Error(problem.description || status.dataset.errorLabel);
      }
      itemAdded = true;
      const cartResponse = await fetch(status.dataset.cartUrl, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('cart-refresh');
      const cart = await cartResponse.json();
      document.querySelectorAll('.cart-link').forEach((link) => {
        link.textContent = `${status.dataset.cartLabel} (${cart.item_count})`;
      });
      status.textContent = status.dataset.addedLabel;

    } catch (error) {
      status.textContent = itemAdded ? status.dataset.refreshLabel : error.message || status.dataset.errorLabel;
    } finally {
      pendingForms.delete(form);
      if (button) button.disabled = false;
      if (itemAdded) {
        const cartLink = document.createElement('a');
        cartLink.href = status.dataset.pageUrl;
        cartLink.textContent = status.dataset.viewLabel;
        status.append(' ', cartLink);
      }
      clearTimeout(statusTimer);
      status.classList.add('is-visible');
      statusTimer = setTimeout(() => {
        status.classList.remove('is-visible');

      }, 6000);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
